// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cancel-document-request{width:352px}.cancel-document-request .modal__header{padding:30px 24px 0}.cancel-document-request p{line-height:1.25;max-width:30em}`, "",{"version":3,"sources":["webpack://./src/modals/CancelDocumentRequest/style.scss"],"names":[],"mappings":"AACA,yBACE,WAAA,CAEA,wCACE,mBAAA,CAGF,2BACE,gBAAA,CACA,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
